module.exports = __webpack_public_path__ + "img/kexuepinggu_jpg_smzlpg.4d0c7435.png";